import React from 'react'
import './link.scss'

const LinkBack = props => {
    const clearSearch = props.clearSearch;

    return (
        <div className="mdn-Link mdn-Link--arrow" onClick={clearSearch}>
            <i className="mdn-Link-anchor-icon mdn-Icon-esquerda mdn-Icon--md"></i>
            <button className="mdn-Link-anchor">Voltar para a lista de canais</button>
        </div>
    )
}

export default LinkBack;